import React, { useEffect, useState } from 'react';
import moment from 'moment'
import { firestore } from '../../../../firebase/firebase'
import { withRouter } from 'react-router-dom';
import JobCard from '../../../components/Reports/Jobs/JobCard'
import { useUser } from '../../../../providers/UserContext';
import useTicket from '../../Ticket/useTicket';
import { makeStyles, Button, Modal, Grid, Paper, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    modal: {
        width: '250px',
        padding: '16px',
        margin: '0 auto',
        marginTop: '50vh',
    },
}));

const Job = (props) => {
    const classes = useStyles();
    const { users, usersLoading, getUsers } = useUser();
    const { createTicketFromSource } = useTicket();

    const [jobData, setJobData] = useState({})
    const [checklistData, setChecklistData] = useState({})
    const [formData, setFormData] = useState([])
    const [unitData, setUnitData] = useState([])
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState('')
    const [ticketModal, setTicketModal] = useState({open: false, data: [], progress: 0, error: null, batchTicket: false})

    useEffect(() => {
        getUsers();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let path = new URLSearchParams(props.location.search).get("docId");

        firestore.collection('jobs').doc(path).get()
            .then(documentSnapshot => {
                let date = documentSnapshot.data().date
                if (date < 9999999999) date *= 1000
                const jobResponse = {
                    ...documentSnapshot.data(),
                    'docId': documentSnapshot.id,
                    'date': moment.utc(date).format('dddd, MMM DD, YYYY'),
                }

                setJobData(jobResponse)

                firestore.collection('checklists').where("jobID", "==", jobResponse.docId).get()
                    .then(querySnapshot => {
                        const checklistResponse = querySnapshot.docs.map((doc) => {
                            return {
                                ...doc.data(),
                                'docId': doc.id,
                            }
                        })
                        setChecklistData(checklistResponse)
                    })

                firestore.collection('documents').where("jobID", "==", jobResponse.docId).get()
                    .then(querySnapshot => {
                        const formResponse = querySnapshot.docs.map((doc) => {
                            return {
                                ...doc.data(),
                                'docId': doc.id,
                            }
                        })
                        setFormData(formResponse)
                    })

                firestore.collection('units').where("timesheetID", "==", jobResponse.timesheetID).get()
                    .then(querySnapshot => {

                        const unitResponse = querySnapshot.docs
                            .filter((unitDoc) => jobResponse.units.includes(unitDoc.id))
                            .map((doc) => {

                                return {
                                    ...doc.data(),
                                    'docId': doc.id,
                                }
                            })
                        setUnitData(unitResponse)
                    })

            }).catch(e => {
                setErrorMessage(e.message);
            }).finally(() => setLoading(false))

    }, [props.location.search])

    function updateUnit(newData) {
        return firestore.collection('units').doc(newData.docId).update(newData).then(() => {
            let newUnitData = [...unitData];
            let unitIndex = unitData.findIndex((unit) => unit.docId === newData.docId);
            newUnitData[unitIndex] = { ...newData };
            setUnitData(newUnitData);
        })
    }

    const handleCreateTicket = (jobArray, batch) => {
        setTicketModal({...ticketModal, progress: 1})
        createTicketFromSource(jobArray, jobData, 'jobs', batch).then((res) => {
            setJobData(res)
            setTicketModal({open: false, data: [], progress: 0, error: null, batchTicket: false})
        }) 
        .catch(err => {
            setTicketModal({open: true, data: [], progress: 0, error: err, batchTicket: false})
        })
    }

    const handleNavigateToTicket = (docIdArray) => {
        props.history.push({
            pathname: '/dashboard/tickets',
            docId: docIdArray[0],
            batch: docIdArray,
        })
    }

    return (
        <>
            {/* send to ticket modal */}
            <Modal
                open={ticketModal.open}
                onClose={() => setTicketModal({...ticketModal, open: false, data: [], error: null, collection: null}) }
            >
                <Paper className={classes.modal}>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        <Typography
                            style={{ margin: '10px', display: 'flex', justifyContent: 'center', fontWeight: '600', }}
                        >
                            Send Job to Tickets?
                        </Typography>
                    </Grid>

                    {
                        ticketModal.data[0]?.units?.length > 1 ?
                        <Grid>
                            <Typography style={{fontSize: '11px'}}>
                                {`Source has more than one unit, create one ticket or multiple based on units?`}
                            </Typography>
                            
                            <Grid style={{display: 'flex', justifyContent: 'center'}}>
                                <Button
                                    variant={ticketModal.batchTicket ? 'outlined' : 'contained'}
                                    style={{margin: '10px', }}
                                    onClick={() => { setTicketModal({...ticketModal, batchTicket: false}) }}
                                >
                                    Single
                                </Button>
                                <Button
                                    variant={ticketModal.batchTicket ? 'contained' : 'outlined'}
                                    style={{margin: '10px'}}
                                    onClick={() => { setTicketModal({...ticketModal, batchTicket: true}) }}
                                >
                                    Batch
                                </Button>
                            </Grid>
                        </Grid>
                        : null
                    }
                    
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            variant={'contained'}
                            style={{margin: '10px', }}
                            onClick={() => { setTicketModal({...ticketModal, open: false, data: [], error: null, batchTicket: false}) }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant={'contained'}
                            style={{margin: '10px'}}
                            disabled={ticketModal.progress !== 0 || ticketModal.error !== null}
                            onClick={() => { handleCreateTicket(ticketModal.data, ticketModal.batchTicket) }}
                        >
                            {ticketModal.progress === 0 ? 'Confirm' : 'Processing'}
                        </Button>
                    </Grid>
                    <Grid style={{display: 'flex', justifyContent: 'center'}}>
                        {ticketModal.error && <Typography style={{color: 'red', marginTop: '5px'}}><small>{ticketModal.error}</small></Typography>}
                    </Grid>
                </Paper>
            </Modal>

            < JobCard
                loading={loading}
                jobData={jobData}
                checklistData={checklistData}
                unitData={unitData}
                userData={users}
                formData={formData}
                usersLoading={usersLoading}
                error={errorMessage}
                updateUnit={updateUnit}
                handleNavigateToTicket={handleNavigateToTicket}
                ticketModal={ticketModal}
                setTicketModal={setTicketModal}
            />
        </>
    )

}

export default withRouter(Job)